import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-embed-header',
  templateUrl: './embed-header.component.html',
  styleUrls: ['./embed-header.component.scss']
})
export class EmbedHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
